import { Form, Row, Col, Button, Modal } from 'react-bootstrap';
import { ActionFunctionArgs, redirect, useNavigate, useSubmit } from 'react-router-dom';
import styled from 'styled-components';
import { addBook } from '../api';
import { Field, Formik, Form as FormikForm } from 'formik';
import { number, object, string } from 'yup';


const StyledButton = styled(Button)`
  background-color: #3498db;
  border-color: #3498db;
  color: #fff;
`;

export async function bookAction({ request }: ActionFunctionArgs) {
  const payload = await request.json();
  await addBook(payload);

  return redirect('/books');
}

const initialValues = {
  title: '',
  author: '',
  isbn: '',
  publication_date: '',
  genre: '',
  description: '',
  units: 0
};

const validationSchema = object({
  title: string().required('Title is required'),
  author: string().required('Author is required'),
  isbn: string().required('ISBN is required'),
  publication_date: string().optional(),
  genre: string().optional(),
  description: string().optional(),
  units: number().required('Units is required')
});

function AddBook() {
  const navigate = useNavigate();
  const submit = useSubmit();

  const handleClose = () => navigate('/books');

  const handleSubmit = (values: any) => {
    submit(values, { method: "post", encType: 'application/json' });
  };

  return (
    <Modal
      show={true}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
    >
      <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
        {({ touched, errors }) => (
          <Form as={FormikForm} noValidate>
            <Modal.Header closeButton>
              <Modal.Title>Add Book</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form.Group as={Row} className="mb-3" controlId="title">
                <Form.Label column sm="4">
                  Title:
                </Form.Label>
                <Col sm="8">
                  <Field
                    as={Form.Control}
                    type='text'
                    name='title'
                    isInvalid={touched.title && !!errors.title}
                  />
                  <Form.Control.Feedback type='invalid'>{errors.title}</Form.Control.Feedback>
                </Col>
              </Form.Group>
              <Form.Group as={Row} className="mb-3" controlId="author">
                <Form.Label column sm="4">
                  Author:
                </Form.Label>
                <Col sm="8">
                  <Field
                    as={Form.Control}
                    type='text'
                    name='author'
                    isInvalid={touched.author && !!errors.author}
                  />
                  <Form.Control.Feedback type='invalid'>{errors.author}</Form.Control.Feedback>
                </Col>
              </Form.Group>
              <Form.Group as={Row} className="mb-3" controlId="isbn">
                <Form.Label column sm="4">
                  ISBN:
                </Form.Label>
                <Col sm="8">
                  <Field
                    as={Form.Control}
                    type='text'
                    name='isbn'
                    isInvalid={touched.isbn && !!errors.isbn}
                  />
                  <Form.Control.Feedback type='invalid'>{errors.isbn}</Form.Control.Feedback>
                </Col>
              </Form.Group>
              <Form.Group as={Row} className="mb-3" controlId="publication_date">
                <Form.Label column sm="4">
                  Publication Date:
                </Form.Label>
                <Col sm="8">
                  <Field
                    as={Form.Control}
                    type='date'
                    name='publication_date'
                    isInvalid={touched.publication_date && !!errors.publication_date}
                  />
                  <Form.Control.Feedback type='invalid'>{errors.publication_date}</Form.Control.Feedback>
                </Col>
              </Form.Group>
              <Form.Group as={Row} className="mb-3" controlId="genre">
                <Form.Label column sm="4">
                  Genre:
                </Form.Label>
                <Col sm="8">
                  <Field
                    as={Form.Control}
                    type='text'
                    name='genre'
                    isInvalid={touched.genre && !!errors.genre}
                  />
                  <Form.Control.Feedback type='invalid'>{errors.genre}</Form.Control.Feedback>
                </Col>
              </Form.Group>
              <Form.Group as={Row} className="mb-3" controlId="units">
                <Form.Label column sm="4">
                  Units:
                </Form.Label>
                <Col sm="8">
                  <Field
                    as={Form.Control}
                    type='number'
                    name='units'
                    isInvalid={touched.units && !!errors.units}
                  />
                  <Form.Control.Feedback type='invalid'>{errors.units}</Form.Control.Feedback>
                </Col>
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="light" onClick={handleClose}>
                Close
              </Button>
              <StyledButton type='submit'>Submit</StyledButton>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}

export default AddBook;
